import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useMutation, useQuery } from 'react-query';
import { useFormContext } from 'react-hook-form';
import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Modal from './Modal/Modal';
import { AdminLayout } from 'src/Layouts';
import { CREATE_RESERVATION_TITLE, RESERVATION_SUCCESS_MESSAGE, ROUTES, } from 'src/Utils';
import { ReservationForm } from './ReservationForm/ReservationForm';
import { ExtraForm } from './ExtraForm/ExtraForm';
import { createReservation, getBlockedDates } from './services';
import { Container, InnerContainer, SuccessSnackbar, Title } from './styles';
import { useAppDispatch } from '../../redux/hooks';
import { setFormSelected } from '../../redux/slices/tableFiltersSlice';
import { formatDate, getSubmitedEnabled } from './utils';
var CreateReservation = function () {
    var push = useHistory().push;
    var dispatch = useAppDispatch();
    var _a = useFormContext(), watch = _a.watch, setValue = _a.setValue, errors = _a.formState.errors;
    var _b = watch(), amenity = _b.amenity, time = _b.time, clientCode = _b.clientCode, date = _b.date, extras = _b.extras, selectedExtras = _b.selectedExtras, startHour = _b.startHour, endHour = _b.endHour;
    var _c = useState(false), open = _c[0], setOpen = _c[1];
    var _d = useState(false), isModalOpen = _d[0], setIsModalOpen = _d[1];
    var blockedDatesResponse = useQuery(['blockedDates', amenity.value], function () {
        return getBlockedDates({
            amenityId: Number(amenity.value),
        });
    }, {
        enabled: !!amenity.value,
    }).data;
    var isDateBlocked = function () {
        var blockedDates = blockedDatesResponse === null || blockedDatesResponse === void 0 ? void 0 : blockedDatesResponse.data.booking_blocked_dates;
        if (!date || !(blockedDates === null || blockedDates === void 0 ? void 0 : blockedDates.length))
            return false;
        var reservationDate = formatDate(date);
        return blockedDates === null || blockedDates === void 0 ? void 0 : blockedDates.some(function (blockedDate) {
            if (blockedDate.recurring) {
                // For recurring dates, check if month and day match
                var blockedDateObj = new Date(blockedDate.date);
                var reservationDateObj = new Date(reservationDate);
                return (blockedDateObj.getMonth() === reservationDateObj.getMonth() &&
                    blockedDateObj.getDate() === reservationDateObj.getDate());
            }
            else {
                // For non-recurring dates, check exact date match
                return blockedDate.date === reservationDate;
            }
        });
    };
    var handleClick = function () { return setOpen(true); };
    var handleClose = function (event, reason) {
        if (reason === 'clickaway')
            return;
        setOpen(false);
        push(ROUTES.reservations);
    };
    var mutateCreateReservation = useMutation(createReservation, {
        onSuccess: function () {
            handleClick();
            setTimeout(function () { return push(ROUTES.reservations); }, 2000);
        },
    })[0];
    var handleProceedWithBlocked = function () {
        return mutateCreateReservation({
            amenityId: Number(amenity.value),
            clientCode: clientCode,
            date: formatDate(date),
            scheduleId: time.value,
            extras: selectedExtras.reduce(function (acc, _a) {
                var name = _a.name, selected = _a.selected;
                if (selected)
                    acc.push(name);
                return acc;
            }, []),
            startHour: startHour,
            endHour: endHour,
        });
    };
    var handleCreateReservation = function () {
        if (isDateBlocked()) {
            setIsModalOpen(true);
            return;
        }
        handleProceedWithBlocked();
    };
    useEffect(function () {
        if (amenity.label) {
            var matchedAmenity = extras.find(function (item) { return item.name === amenity.label; });
            if (matchedAmenity)
                setValue('selectedExtras', matchedAmenity.extras);
        }
    }, [extras, amenity]);
    useEffect(function () {
        setValue('time', {
            label: '',
            value: 0,
            price: 0,
        });
    }, [amenity, date]);
    useEffect(function () {
        dispatch(setFormSelected(true));
    }, []);
    return (React.createElement(AdminLayout, null,
        React.createElement(Container, null,
            React.createElement(Title, null, CREATE_RESERVATION_TITLE),
            React.createElement(InnerContainer, null,
                React.createElement(ReservationForm, null),
                React.createElement(ExtraForm, { handleCreateReservation: handleCreateReservation, isSubmitEnabled: getSubmitedEnabled(watch, errors) }))),
        React.createElement(SuccessSnackbar, { anchorOrigin: {
                vertical: 'top',
                horizontal: 'right',
            }, open: open, autoHideDuration: 2000, onClose: handleClose, message: RESERVATION_SUCCESS_MESSAGE, action: React.createElement(IconButton, { size: "small", color: "inherit", onClick: handleClose },
                React.createElement(CloseIcon, { fontSize: "small" })) }),
        React.createElement(Modal, { isOpen: isModalOpen, setIsOpen: setIsModalOpen, handleCancel: handleProceedWithBlocked, description: '' })));
};
export default CreateReservation;
